import { useMutation, useQueryClient } from '@tanstack/react-query';
import { adminFetch } from '@/lib/apiClient';
import { throwFromResponse } from '../lib/apiErrorMessage';

export interface GradeAssignInput {
  userId: string;
  gradeId: string;
  /** 필수 — BE @NotBlank(최대 255자, 감사 이력). */
  reason: string;
}

export const useUserGradeAssignMutation = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ userId, gradeId, reason }: GradeAssignInput) => {
      const res = await adminFetch(`/api/admin/v1/users/${userId}/grade`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ gradeId, reason }),
      });
      if (!res.ok) await throwFromResponse(res, '회원 등급 변경에 실패했습니다.');
    },
    onSuccess: (_data, { userId }) => {
      void qc.invalidateQueries({ queryKey: ['admin', 'users', 'detail', userId] });
      void qc.invalidateQueries({ queryKey: ['admin', 'user-grades'] });
    },
  });
};
